/* import __COLOCATED_TEMPLATE__ from './dining-option-selector-field.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { feature } from '@square/ember-features/macros';
let DiningOptionSelectorField = (_dec = feature('fulfillment/enable-fulfillment-methods-dashboard'), _class = class DiningOptionSelectorField extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isModalOpen", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "enableFulfillmentMethods", _descriptor3, this);
  }
  get diningOptionsLabel() {
    if (this.args.selectedDiningOptions.length === 0) {
      return this.noDiningOptionsLabel;
    } else if (this.args.selectedDiningOptions.length === 1) {
      const [diningOption] = this.args.selectedDiningOptions;
      return diningOption.name;
    } else if (this.args.selectedDiningOptions.length === this.args.diningOptions.length) {
      return this.allDiningOptionsLabel;
    } else {
      return this.getMultipleDiningOptionsLabel(this.args.selectedDiningOptions.length);
    }
  }
  get selectedDiningOptionIds() {
    return new Set(this.args.selectedDiningOptions.map(diningOption => diningOption.id));
  }
  get options() {
    return this.args.diningOptions.map(diningOption => ({
      checked: this.selectedDiningOptionIds.has(diningOption.id),
      label: diningOption.name,
      value: diningOption.id
    }));
  }
  get modalOptions() {
    return {
      title: this.noDiningOptionsLabel,
      selectAllLabel: this.allDiningOptionsLabel,
      primaryButtonLabel: this.intl.t('sharedUi.common.done'),
      options: this.options,
      enableIndeterminateState: true,
      allowDisablingPrimaryButton: false
    };
  }
  getMultipleDiningOptionsLabel(count) {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.diningOptionSelectorField.fulfillmentMethod.label.multipleOptions' : 'sharedUi.diningOptionSelectorField.label.multipleOptions', {
      count
    });
  }
  get allDiningOptionsLabel() {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.diningOptionSelectorField.fulfillmentMethod.label.allOptions' : 'sharedUi.diningOptionSelectorField.label.allOptions');
  }
  get noDiningOptionsLabel() {
    return this.intl.t(this.enableFulfillmentMethods ? 'sharedUi.selectFulfillmentMethods' : 'sharedUi.selectDiningOptions');
  }
  open() {
    this.isModalOpen = true;
  }
  closeModal(event) {
    this.isModalOpen = false;
    if (!Array.isArray(event)) {
      return;
    }
    const selectedDiningOptionIds = event.reduce((selectedDiningOptionIds, {
      value,
      checked
    }) => {
      if (checked) {
        selectedDiningOptionIds.add(value);
      }
      return selectedDiningOptionIds;
    }, new Set());
    this.args.onChange(selectedDiningOptionIds);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enableFulfillmentMethods", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _class);
export { DiningOptionSelectorField as default };